module.exports = __webpack_public_path__ + "img/invest.17f7b354.png";